import initCarousel from '../helpers/carousel';
import ProductItem from '../components/product/ProductItem';

export default class DynamicTestimonials {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    const selectors = {
      productItem: '[data-product-item]',
      testimonialsCarousel: '[data-testimonials-carousel]',
      testimonialsMedia: '[data-testimonials-media]',
      prevButton: '.splide__arrow--prev',
      nextButton: '.splide__arrow--next',
      currentCounter: '[data-carousel-counter]',
    };

    this.testimonialsCarousel = this.el.querySelector(
      selectors.testimonialsCarousel,
    );
    this.testimonialsMedia = this.el.querySelector(selectors.testimonialsMedia);
    this.prevButton = this.el.querySelector(selectors.prevButton);
    this.nextButton = this.el.querySelector(selectors.nextButton);
    this.currentCounter = this.el.querySelector(selectors.currentCounter);

    const productItems = this.el.querySelectorAll(selectors.productItem);
    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });

    this._initCarousels();
  }

  _initCarousels() {
    if (!this.testimonialsCarousel || !this.testimonialsMedia) {
      return;
    }

    /** Initialize content carousel */
    this.mainCarousel = initCarousel(
      this.testimonialsCarousel,
      {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        pagination: false,
        arrows: true,
      },
      true,
    );

    /** Initialize media carousel */
    this.mediaCarousel = initCarousel(
      this.testimonialsMedia,
      {
        type: 'fade',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        pagination: false,
        arrows: false,
        drag: false,
      },
      true,
    );

    /** Sync both carousels */
    if (this.mainCarousel && this.mediaCarousel) {
      this.mainCarousel.sync(this.mediaCarousel);
    }
  }
}
